<dashboardnav>
  <cradua-acquisitiontype [acquisitiontypes]="acquisitiontypes$ | async" (acquisitiontype)="onSubmitAcquisitionType($event)" (deleteAcquisitionTypeEvent)="onDeleteAcquisitionType($event)"
    *ngIf="(isLoadingAcquisitionType$ | async ) === false">
  </cradua-acquisitiontype>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingAcquisitionType$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
